import type { SVGProps } from 'react';

const Discharge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M3.3335 7.59668H11.2257"
      stroke="#111927"
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.07861 13.0889H7.45116"
      stroke="#292D32"
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.16699 13.0889H11.9121"
      stroke="#292D32"
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.059 9.33464V12.8209C17.059 15.2297 16.4482 15.8337 14.0119 15.8337H6.38056C3.94428 15.8337 3.3335 15.2297 3.3335 12.8209V7.17974C3.3335 4.77091 3.94428 4.16699 6.38056 4.16699H11.2257"
      stroke="#292D32"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.2852 5.88268L14.3146 6.91209L17.0597 4.16699"
      stroke="#292D32"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default Discharge;
